import { render } from "./PhosphoriconsPage.vue?vue&type=template&id=2c67685e&ts=true"
import script from "./PhosphoriconsPage.vue?vue&type=script&lang=ts"
export * from "./PhosphoriconsPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__